import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportGraphSize } from 'types';

export type OwnProps = {
    size: ReportGraphSize;
    checked: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
};

const resolutionStyle = {
    opacity: .5,
    marginLeft: '1em',
};

const RawGraphSizeOption = ({ size, checked, onChange, t }: OwnProps & TranslateProps) =>
    <div>
        <input
            id={ `edit-report-graph-size-${size.id}` }
            type="radio"
            checked={ checked }
            value={ size.id }
            onChange={ onChange }
        />
        <label
            htmlFor={ `edit-report-graph-size-${size.id}` }
        >
            <span>
                { t(`WC_REPORT_GRAPH_SIZE_${size.id.toUpperCase()}`) }
            </span>
            <span style={ resolutionStyle }>
                { `(${size.width} x ${size.height})` }
            </span>
        </label>
    </div>
;

export const GraphSizeOption = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('GraphSizeOption'),
    translate(),
)(RawGraphSizeOption);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/graph/GraphSizeOption.tsx